import { useTenantConfiguration } from '@msdk/common'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

type Props = {
  pageTitle?: string
}

/**
 * Component for managing page information in the document head.
 *
 * @param {string} props.pageTitle - The title of the page.
 * @returns {JSX.Element} The rendered PageInformation component.
 */
export function PageInformation(props: Props) {
  const { pageTitle } = props

  const tenant = useTenantConfiguration()

  useEffect(() => {
    const prev = document.title
    document.title = (tenant?.productName ?? 'Fresenius Medical Care') + (pageTitle?.length ? ` - ${pageTitle}` : '')
    return () => {
      document.title = prev
    }
  }, [tenant, pageTitle])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
      </Helmet>
    </>
  )
}
